export default function() {
    this.loadSetting()
}
